<template>
    <div class="lottery-wrap">
        <div class="nav-top">
            <a class="return-a" @click="back"></a>
            <h3 class="nav-title">{{txtLang[langName]['luckyDraw']}}</h3>
        </div>

        <!--个人信息-->
        <div class = "person">
            <div class = "p_box flex flex-align-center">
                <div class = "pb_left">
                    <img src = "../../static/image/icon_coin.png" />
                    <p>{{txtLang[langName]['myCoins']}}</p>
                </div>
                <div v-if = "ifLogin" class = "pb_num flex-1">
                    <p :class = "aniCoinSH ? 'p_coin' : ''">{{moneyStr(lotteryUser.coins)}}<b>{{aniCoinNum}}</b></p>
                </div>
                <div v-else class = "pb_loginBtn flex-1">
                    <a @click="toGo">{{txtLang[langName]['login']}}</a>
                </div>
            </div>
        </div>
        <!--转盘tab-->
        <div class="lottery-tab">
            <ul class="lottery-list">
                <li v-for="(val,key) in txtLang[langName]['lotteryTab']" :class="(lotteryTab==key ? 'on' : '')" @click="lotteryTabClick(key)">{{val}}</li>
            </ul>
        </div>
        <!--转盘-->
        <div class="lottery-box">
            <p class="lottery-tips" v-if="ifLogin==0">{{txtLang[langName]['lotteryNoLogin']}}</p>
            <p class="lottery-tips" v-else-if="ifLogin==1&&is_free==1" v-html="stringSub(txtLang[langName]['lotteryFreeChangeTips'], '#p', moneyStr(free_chance>0 ? free_chance : 0))"></p>
            <p class="lottery-tips" v-else-if="ifLogin==1&&is_free==0" v-html="stringSub(txtLang[langName]['lotteryChangeTips'], '#p', moneyStr(chance))"></p>
            <div :class="('lottery-title-flag-' + curLang)"></div>
            <div class="lottery">
                <div class="lottery-item">
                    <div class="lottery-start">
                        <div class="box" @click="startLottery" v-if="isStart==1">
                            <p :class="['prize_num', is_free==0?'prize_i':'']">{{is_free==1? txtLang[langName]['lotteryFree'] : '-' + moneyStr(lotteryCoins)}}</p>
                        </div>
                        <div class="box gray" v-if="isStart==2"></div>
                    </div>
                    <ul>
                        <li v-for="(item,i) in list" :class="i==index?'on':''">
                            <div class="container">
                                <div :class="['flip', flip ? 'flip_on' : '']">
                                    <div class="box front">
                                        <p class="prize_img flex flex-align-center"><span class=""><img :src="item.image"></span></p>
                                        <p class="prize_title">{{item.title}}</p>
                                    </div>
                                    <div class="back"></div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="lottery-footer-flag"></div>
        </div>
        <!-- 中奖弹窗 -->
        <div class="mask" v-if="showToast"></div>
        <div class="lottery-alert" v-if="showToast">
            <div :class="('lottery-sorry-' + curLang)" v-if="lottery.type==0"></div>
            <div :class="('lottery-win-' + curLang)" v-if="lottery.type>0"></div>
            <h3 class="lottery-win-title" v-if="lottery.type>0"></h3>
            <div class="lottery-win-box" v-if="lottery.type>0">
                <div class="lottery-win-img flex flex-align-center"><img :src="prizeImg[lottery.type]" /></div>
                <p class="lottery-win-name">{{lottery.title !='' ? lottery.title : stringSub(txtLang[langName]['lotteryWinName'][lottery.type], '#p', moneyStr(lottery.value))}}</p>
                <p class="lottery-win-tips" v-if="lottery.type==3">{{txtLang[langName]['lotteryWinTips']}}</p>
            </div>
            <p class="lottery-sorry-txt" v-if="lottery.type==0">{{txtLang[langName]['lotterySorryTips']}}</p>
            <div class="btnsave" @click="confirmBtn"><p class="btnsave-text">{{lottery.type==3 ? txtLang[langName]['lotteryCheck'] : txtLang[langName]['lotteryConfirm']}}</p></div>
        </div>
        <!--tab-->
        <div class="nav-tab">
            <ul class="tab-list">
                <li v-for="(val, key) in txtLang[langName]['lotteryNavTab']" :class="(tabIndex==key ? 'on' : '')" @click="tabClick(key)">{{val}}</li>
            </ul>
        </div>
        <!--抽奖规则-->
        <div class="lottery-rule" v-if="(tabIndex==0)">
            <p v-html = "lotteryRule"></p>
        </div>
        <!--中奖记录-->
        <div class="lottery-record" v-else-if="(tabIndex==1)">
            <div class="lottery-record-title"  v-if = "isLoadingShow == false && recordList.length > 0">
                <span>{{txtLang[langName]['lotteryPrize']}}</span>
                <span>{{txtLang[langName]['lotteryWinTime']}}</span>
            </div>
            <ul class="lottery-record-list" v-if = "isLoadingShow == false && recordList.length > 0">
                <li v-for="(val, key) in recordList">
                    <p class="lottery-record-con">
                        <span>{{val.content}}</span>
                        <span>{{val.time}}</span>
                    </p>
                    <p class="lottery-record-code" v-if="val.type == 3">{{val.code != '' ? txtLang[langName]['eShopCode'] + val.code : txtLang[langName]['lotteryCodeTips']}}<a class="copy-btn" @click="copy(val.code)" v-if="val.code != ''">{{txtLang[langName]['eCopy']}}</a></p>
                </li>
            </ul>
            <noneBox v-else-if = "isLoadingShow == false && recordList.length == 0" :noData="txtLang[langName]['noData']"></noneBox>
            <div class="lottery-btn" v-if="loadNext==1">
                <a class="lottery-list-more" @click="loadMore">{{txtLang[langName]['lotteryMore']}}</a>
            </div>
        </div>

        <!--loading-->
        <Loading v-show="isLoadingShow"></Loading>
        <!--confirm层-->
        <confirm ref="myConfirm"></confirm>
        <!---->
        <Alert ref="Alert" :txt = "alertTip" :time = "1000"/>
    </div>
</template>

<script>
    import Loading from './common/Loading';
    import noneBox from './common/None';
    import confirm from './common/Confirm';
    import Alert from './common/Alert';
    import qs from 'qs';

    export default {
        name: "lotteryIndex",
        components:{
            Loading,
            noneBox,
            confirm,
            Alert
        },

        data(){
          return {
              isLoadingShow: false,
              ifLogin:0,//是否登录 0-否, 1-是
              lotteryTab:0, //抽奖tab切换
              tabIndex:0, //记录tab切换
              lotteryRule: '', //抽奖规则
              lotteryCoins: 0, //抽奖所需m币
              lotteryUser: {}, //用户信息
              current: 1, //中奖记录当前页码
              page_size: 10, //中奖记录一页显示条数
              recordList: [],
              loadNext: 0,
              chance: 0, //用户剩余付费抽奖机会
              free_chance: 0, //用户剩余免费抽奖机会
              is_free: 1, //抽奖类型 1-免费, 0-
              click2: true, // 转盘tab是否可点
              alertTip: '',

              lottery: {}, //抽奖数据

              isStart:1,
              score: 500, // M币剩余最低基数
              list:[],   //奖品
              index: -1,  // 当前转动到哪个位置，起点位置
              count: 8,  // 总共有多少个位置
              timer: 0,  // 每次转动定时器
              speed: 200,  // 初始转动速度
              times: 0,    // 转动次数
              cycle: 50,   // 转动基本次数：即至少需要转动多少次再进入抽奖环节
              prize: -1,   // 转动停止位置
              click: true, //抽奖按钮是否可点
              flip: false,
              showToast: false, // 显示中奖弹窗
              prizeImg: [
                  '',
                  '../../static/image/prize_coupons.png',
                  '../../static/image/prize_coin.png',
                  '../../static/image/prize_ama.png'
              ], // 中奖图片
          }
        },

        methods: {
            back(){//返回上一层
                if(window.location.href.indexOf('accounts') != -1){
                    this.$router.go(-3);
                }else{
                    this.$router.go(-1);
                }
            },

            /**
             * 登录跳转
             */
            toGo: function(){
                this.gotoLogin();
            },

            /**
             * 抽奖tab
             */
            lotteryTabClick(index){
                if (!this.click2) { return }
                this.lotteryTab = index;
                this.flip = false;

                if(index == 0){
                    this.is_free = 1;
                }else if(index == 1){
                    this.is_free = 0;
                }

                if(this.ifLogin == 1) {
                    if ((this.is_free == 1 && this.free_chance > 0) || (this.is_free == 0 && this.chance > 0)) {//免费或付费抽奖次数不为0
                        this.isStart = 1;
                        this.click = true;
                    } else {
                        this.isStart = 2;
                        this.click = false;
                    }
                }

                this.prizeList({
                    token: localStorage.getItem('guess_token'),
                    lan: this.langIndex,
                    is_free: this.is_free
                });
            },

            /**
             * 记录tab
             */
            tabClick(index){
                const that = this;
                if(index == 1 && this.ifLogin == 0){// 兑换记录，未登录
                    this.$refs.myConfirm.show(this.txtLang[this.langName]['loginFirst'], {
                        titleType: 0,
                        styleType: 1,
                        cancelText: this.txtLang[this.langName]['confirmCancel'],
                        confirmText: this.txtLang[this.langName]['confirmText'],
                        titleText: ' ',
                        data: function(){
                            that.toGo();
                        }
                    });
                    return;
                }

                this.tabIndex = index;
                if(index == 1){
                    this.recordList = [];
                    this.current = 1;
                    this.lotteryWinLog();
                }
            },

            /**
             * 奖品列表
             */
            prizeList(options){
                var defaults = {
                    token: '',
                    lan: 'en',
                    is_free: 1,
                };
                defaults = Object.assign(defaults, options);

                const that  = this;

                this.axios.get(this.getHost() + "/mall/lottery-list?lan="+defaults.lan+'&token='+defaults.token+'&is_free='+defaults.is_free).then((response) => {

                    var re = response.data;
                    if(re.code == 200){
                        that.list = re.data;
                    }
                }).catch((response) => {
                    console.log(response)
                });
            },

            /**
             * 抽奖配置
             */
            lotterySet(options){
                var defaults = {
                    token: '',
                    lan: 'en',
                    success: null
                };
                defaults = Object.assign(defaults, options);

                const that = this;
                //that.isLoadingShow = true;

                this.axios.get(this.getHost() + "/mall/lottery-config?lan="+defaults.lan+'&token='+defaults.token).then((response) => {
                    that.isLoadingShow = false;

                    var re = response.data;
                    if(re.code == 200){
                        that.lotteryUser = re.data.user;
                        that.ifLogin = re.data.user.is_login;
                        that.chance = re.data.user.chance;
                        that.free_chance = re.data.user.free_chance;
                        that.lotteryCoins = re.data.config["coins"];
                        that.lotteryRule = re.data.help;

                        if(that.ifLogin == 1){//已登录
                            if(that.free_chance > 0){
                                that.is_free = 1;
                                that.isStart = 1;
                                that.lotteryTab = 0;
                            }else{
                                that.is_free = 0;
                                that.isStart = 2;
                                that.lotteryTab = 1;
                            }

                            if(this.is_free == 0 && this.chance > 0){
                                that.isStart = 1;
                            }
                        }else{//未登录

                        }

                        if(defaults.success != null){
                            defaults.success();
                        }
                    }
                }).catch((response) => {
                    console.log(response)
                });
            },

            /**
             * 中奖记录
             */
            lotteryWinLog(){
                var defaults = {
                    token: localStorage.getItem('guess_token'),
                    lan: this.langIndex
                };

                const that = this;
                //that.isLoadingShow = true;

                this.axios.get(this.getHost() + "/mall/win-log?lan="+defaults.lan+'&token='+defaults.token +'&current='+ that.current + '&page_size=' + that.page_size).then((response) => {
                    that.isLoadingShow = false;

                    var re = response.data;
                    if(re.code == 200){
                        that.recordList = [...that.recordList, ...re.data.list]
                        that.loadNext = re.data.next;
                    }
                }).catch((response) => {
                    console.log(response)
                });
            },

            /**
             * 复制
             */
            copy(data){
                let code = data;
                let oInput = document.createElement('input');
                oInput.value = code;
                document.getElementById('app').appendChild(oInput);
                oInput.select(); // 选择对象;
                document.execCommand("Copy"); // 执行浏览器复制命令
                this.alertTip = this.txtLang[this.langName]['eCopySuccess'];
                this.$refs.Alert.show();
                oInput.remove();
            },

            /**
             * 加载更多
             */
            loadMore(){
                const that = this;
                that.current += 1;
                that.lotteryWinLog();
            },

            /**
             * 抽奖请求
             */
            lotteryData(options){
                var defaults = {
                    token: localStorage.getItem('guess_token'),
                    lan: this.langIndex,
                    success: null
                };

                defaults = Object.assign(defaults, options);

                const that = this;

                this.axios.post(this.getHost() + '/mall/lottery', qs.stringify({
                    token: defaults.token,
                    lan: defaults.lan,
                    is_free: this.is_free
                })).then((response) => {

                    var re = response.data;
                    if(re.code == 200){
                        that.lottery = re.data;

                        localStorage.setItem('lotteryObject', JSON.stringify(that.lottery));//保存抽奖数据
                    }else if(re.code == 423){//封号
                        this.alertTip = this.txtLang[this.curLang]['sealAccout'];
                        this.$refs.Alert.show();
                        return;
                    }

                    if(defaults.success != null){
                        defaults.success(re.code);
                    }
                }).catch((response) => {
                    console.log(response);
                });
            },

            /**
             * 弹窗按钮
             */
            confirmBtn(){
                localStorage.removeItem('lotteryObject');//删除保存的抽奖数据

                this.flip = false;

                if(this.lottery.type == 3){
                    this.goToCheck();
                }else{
                    this.showToast = false; //关闭弹窗

                    if(this.lottery.type == 2){// 加M币
                        this.aniCoinShow('+' + this.moneyStr(this.lottery.value));
                    }
                }
            },

            /**
             * 前往查看
             */
            goToCheck(){
                this.showToast=false;
                this.tabClick(1);
            },

            /**
             * 抽奖按钮
             */
            startLottery(){
                if (!this.click) { return }
                if(this.ifLogin == 0){ //未登录跳转登录
                    this.gotoLogin();
                    return;
                }

                if(this.is_free == 0 && (this.lotteryUser.coins - this.lotteryCoins) < this.score){ // 账户M币不足
                    this.$refs.myConfirm.show(this.txtLang[this.langName]['lotteryMCoinNo'], {
                        type: 'alert',
                        titleType: 0,
                        styleType: 1,
                        confirmText: this.txtLang[this.langName]['lotteryClose'],
                        titleText: ' '
                    });
                    return;
                }

                const that = this;

                this.lotteryData({ //抽奖
                    success: function(code){
                        if(code==200){
                            that.click = false;
                            that.click2 = false;
                            that.isStart = 2;
                            that.flip = true;

                            if(that.is_free == 1 && that.free_chance > 0){ // 免费次数-1
                                that.free_chance -= 1;
                            }else if(that.is_free == 0 && that.chance > 0){ //付费次数-1
                                that.chance -= 1;
                                that.lotteryUser.coins = that.lotteryUser.coins - that.lotteryCoins;
                            }

                            that.startRoll();
                        }
                    }
                });
            },

            /**
             * 开始转动
             */
            startRoll () {
                this.times += 1; // 转动次数
                this.oneRoll(); // 转动过程调用的每一次转动方法，这里是第一次调用初始化
                // 如果当前转动次数达到要求 && 目前转到的位置是中奖位置
                if (this.times > this.cycle + 10 && this.prize == this.index) {
                    clearTimeout(this.timer); // 清除转动定时器，停止转动
                    this.prize = -1;
                    this.times = 0;
                    this.speed = 200;
                    var that = this;
                    that.showToast = true;
                    that.click2 = true;
                    if(that.lottery.type == 2){
                        that.lotteryUser.coins += that.lottery.value;

                        let _chance = parseInt((that.lotteryUser.coins - that.score)/that.lotteryCoins);
                        that.chance = (_chance > 0 ? _chance : 0);
                    }

                    if((this.is_free==1&&this.free_chance > 0) || (this.is_free==0&&this.chance > 0)) {//免费或付费抽奖次数不为0
                        setTimeout(res => {
                            this.click = true;
                            this.isStart = 1;
                        }, 500)
                    }
                } else {
                    if (this.times < this.cycle) {
                        this.speed -= 10  // 加快转动速度
                    } else if (this.times == this.cycle) {
                        const index = parseInt(Math.random() * 10, 0) || 0;  // 随机获得一个中奖位置
                        this.prize = index; //中奖位置,可由后台返回
                        if (this.prize > 7) { this.prize = 7 }
                    } else if (this.times > this.cycle + 10 && ((this.prize == 0 && this.index == 7) || this.prize == this.index + 1)) {
                        this.speed += 110
                    } else {
                        this.speed += 20
                    }
                    if (this.speed < 40) {this.speed = 40}
                    this.timer = setTimeout(this.startRoll, this.speed)
                }
            },

            /**
             * 每一次转动
             */
            oneRoll () {
                let index = this.index; // 当前转动到哪个位置
                const count = this.count; // 总共有多少个位置
                index += 1;
                if (index > count - 1) { index = 0 }
                this.index = index
            },
        },

        mounted(){
            const that = this;

            var _lottery = localStorage.getItem('lotteryObject');
            if(_lottery != null){
                that.lottery = JSON.parse(_lottery);
                that.showToast = true;
            }
            this.isUserLogin({
                source: this.source[this.langName],
                platform: 2,
                success: function(data){
                    that.lotterySet({
                        token: localStorage.getItem('guess_token'),
                        lan: that.langIndex,
                        success: function(){
                            that.prizeList({
                                token: localStorage.getItem('guess_token'),
                                lan: that.langIndex,
                                is_free: that.is_free
                            });
                        }
                    });
                }
            });
            /*this.lotterySet({
                token: localStorage.getItem('guess_token'),
                lan: this.langIndex,
                success: function(){
                    that.prizeList({
                        token: localStorage.getItem('guess_token'),
                        lan: that.langIndex,
                        is_free: that.is_free
                    });
                }
            });*/
        }
    }
</script>

<style>
    .lottery-wrap{background:url(../../static/image/lottery_bg.png) no-repeat 0 255px;background-size:100% auto;overflow:hidden;}
    /* 顶部菜单 */
    .nav-top{width:100%;height:120px;text-align:center;background:#232048;position:fixed;z-index:110;top:0;left:0;}
    .return-a{display:inline-block;width:120px;height:120px;position:absolute;top:0;left:0;}
    .return-a:after{content:'';position:absolute;width:20px;height:20px;top:50%;left:50%;border-top:4px solid #fff;border-left:4px solid #fff;transform:translate(-50%,-50%) rotate(-45deg);-webkit-transform:translate(-50%,-50%) rotate(-45deg);-moz-transform:translate(-50%,-50%) rotate(-45deg);-o-transform:translate(-50%,-50%) rotate(-45deg);-ms-transform:translate(-50%,-50%) rotate(-45deg);}
    .nav-title{width:64%;margin:0 auto;line-height:120px;color:#fff;font-size:40px;font-weight:normal;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
    /*金币栏*/
    .person{padding-top:120px;width:100%;background:#131229;}
    .personTop{height:116px}
    .person .p_box{height:116px;padding:0 55px;font-size:0;position:relative}
    .person .p_box .pb_left{text-align:center;display:inline-block;margin-right:12px}
    .person .p_box .pb_left img{display:block;width:40px;height:40px;margin:0 auto}
    .person .p_box .pb_left p{color:#bbbabf;font-size:18px;}
    .person .p_box .pb_num p{display:inline-block;font-size:30px;color:#fd7446;font-weight:bold;}
    .person .p_box .pb_loginBtn a{display:block;border-radius:30px;width:200px;height:58px;text-align:center;line-height:58px;background:#6371ea;color:#fff;font-size:30px;}
    /*转盘tab*/
    .lottery-tab{padding:40px 24px 0;}
    .lottery-list{display:flex;}
    .lottery-list li{flex:1;height:68px;line-height:68px;color:#6770e6;font-size:30px;text-align:center;border:4px solid #6770e6;background:#232048;}
    .lottery-list li:first-child{border-radius:16px 0 0 16px;}
    .lottery-list li:last-child{border-radius:0 16px 16px 0;}
    .lottery-list li.on{color:#fff;background:#6770e6;}
    /*转盘*/
    .lottery-box{padding:40px 0 0;}
    .lottery-tips{height:40px;line-height:40px;margin-bottom:40px;color:#fff;font-size:20px;text-align:center;}
    .lottery-tips strong{display:inline-block;margin-right:10px;color:#d476e2;font-size:40px;}
    .lottery-title-flag-en, .lottery-title-flag-kr, .lottery-title-flag-th, .lottery-title-flag-kr{width:550px;height:98px;margin:0 auto;background:url(../../static/image/lottery_title_en.png) no-repeat center 0;background-size:100% auto;}
    .lottery-title-flag-kr{background-image:url(../../static/image/lottery_title_kr.png);}
    .lottery-title-flag-th{background-image:url(../../static/image/lottery_title_th.png);}
    .lottery-title-flag-vn{background-image:url(../../static/image/lottery_title_vn.png);}
    .lottery-footer-flag{width:363px; height:69px;margin:-19px auto 0;background:url(../../static/image/lottery_footer.png) no-repeat center;background-size:100% auto;}
    .lottery {/*animation: changeBg .5s linear infinite;-webkit-animation: changeBg .5s linear infinite;-moz-animation: changeBg .5s linear infinite;-o-animation: changeBg .5s linear infinite;-ms-animation: changeBg .5s linear infinite;*/overflow: hidden;padding: 26px 0 0 25px;width:640px;height:666px;margin:-25px auto 0;background:url(../../static/image/lottery_draw_01.png) no-repeat 0 0;background-size: 100% 100%;}
    @keyframes changeBg {
        0% {
            background-image:url(../../static/image/lottery_draw_01.png);
        }
        100% {
            background-image:url(../../static/image/lottery_draw_02.png);
        }
    }
    @-webkit-keyframes changeBg {
        0% {
            background-image:url(../../static/image/lottery_draw_01.png);
        }
        100% {
            background-image:url(../../static/image/lottery_draw_02.png);
        }
    }
    @-moz-keyframes changeBg {
        0% {
            background-image:url(../../static/image/lottery_draw_01.png);
        }
        100% {
            background-image:url(../../static/image/lottery_draw_02.png);
        }
    }
    @-o-keyframes changeBg {
        0% {
            background-image:url(../../static/image/lottery_draw_01.png);
        }
        100% {
            background-image:url(../../static/image/lottery_draw_02.png);
        }
    }
    @-ms-keyframes changeBg {
        0% {
            background-image:url(../../static/image/lottery_draw_01.png);
        }
        100% {
            background-image:url(../../static/image/lottery_draw_02.png);
        }
    }
    .lottery .lottery-item {height: 626px;position: relative;}
    .lottery .lottery-item ul li {width:186px;position:absolute;top:8px;left:8px;}
    .lottery .lottery-item ul li:nth-child(2) {left:202px;}
    .lottery .lottery-item ul li:nth-child(3) {left:396px;}
    .lottery .lottery-item ul li:nth-child(4) {left:396px;top:202px;}
    .lottery .lottery-item ul li:nth-child(5) {left:396px;top:396px;}
    .lottery .lottery-item ul li:nth-child(6) {left:202px;top:396px;}
    .lottery .lottery-item ul li:nth-child(7) {top:396px;}
    .lottery .lottery-item ul li:nth-child(8) {top:202px;}
    .lottery .lottery-item ul li .box {height: 186px;position: relative;text-align: center;overflow: hidden;background: url(../../static/image/lottery_item.png) no-repeat center;background-size: 100% 100%;}
    .lottery .lottery-item ul li .box img {width:40%;margin:0 auto;}
    .lottery .lottery-item ul li .box p.prize_img{width:100%;height:110px;margin-top:8px;}
    .lottery .lottery-item ul li .box p.prize_img span{display:inline-block;width:100%;vertical-align:middle;text-align:center;}
    .lottery .lottery-item ul li .box p.prize_title {line-height:24px;color: #5861c7;font-size: 18px;
    }
    .prize_num{height:36px;line-height:36px;margin:120px 18px 0;color:#fff;font-size:24px;text-align:center;border-radius:18px;background:#f3a318;}
    .prize_i{background:#f3a318 url(../../static/image/icon_sign2.png) no-repeat 95% center;background-size:auto 70%;}

    .container{transform-style:preserve-3d;}
    .container,.front,.back{width:186px;height:186px;}
    .flip{position:relative;transition:0.6s;transform-style:preserve-3d;}
    .front,.back{position:absolute;top: 0;left: 0;}
    .front{z-index:2;}
    .back{background:url(../../static/image/lottery_item_back.png) no-repeat 0 0;background-size:100% auto;transform:rotateY(-180deg);}
    .flip_on{transform:rotateY(180deg);}
    .flip_on .front{display:none;}
    .flip_on .back{z-index:3;}
    .lottery .lottery-item ul li.on .back {background: url(../../static/image/lottery_item_back_on.png) no-repeat center;background-size: 100% 100%;}

    .lottery .lottery-item .lottery-start {position: absolute;left:202px;width:186px;top: 202px;}
    .lottery .lottery-item .lottery-start .box {height: 186px;font-size: 14px;color: #fff;cursor: pointer;text-align: center;overflow: hidden;background: url(../../static/image/lottery_go.png) no-repeat center;background-size: 100% 100%;}
    .lottery .lottery-item .lottery-start .box p b {font-size: 40px;margin-top: 16px;margin-bottom: 15px;line-height: 30px;display: block;}
    .lottery .lottery-item .lottery-start .box:active {opacity: 0.7;}
    .lottery .lottery-item .lottery-start .box.gray {background: url(../../static/image/lottery_go_gray.png) no-repeat center; background-size: 100% 100%;}
    .lottery .lottery-item .lottery-start .box.gray p {color: #708ABF;font-weight: bold;}
    .mask {width: 100%;height: 100%;background: rgba(0,0,0,0.7);position: fixed;overflow: hidden;z-index: 222;top: 0;left: 0;}
    .lottery-alert {width: 640px;text-align: center;z-index: 10000;border-radius: 16px;background: #6770e6;position: fixed;left: 0;right: 0;margin:0 auto;top: 50%;transform: translateY(-50%);-webkit-transform: translateY(-50%);-moz-transform: translateY(-50%);-o-transform: translateY(-50%);-ms-transform: translateY(-50%);}
    .lottery-win-en, .lottery-win-kr, .lottery-win-th, .lottery-win-vn{width:600px;height:242px;margin:0 auto;background:url(../../static/image/lottery_en.png) no-repeat center 0;background-size:100% auto;position:absolute;top:-142px;left:50%;transform: translateX(-50%);-webkit-transform: translateX(-50%);-moz-transform: translateX(-50%);-o-transform: translateX(-50%);-ms-transform: translateX(-50%);}
    .lottery-win-kr{background-image:url(../../static/image/lottery_kr.png);}
    .lottery-win-th{background-image:url(../../static/image/lottery_th.png);}
    .lottery-win-vn{background-image:url(../../static/image/lottery_vn.png);}
    .lottery-sorry-en, .lottery-sorry-kr, .lottery-sorry-th, .lottery-sorry-vn{width:550px;height:168px;margin:0 auto;background:url(../../static/image/no_lottery_en.png) no-repeat center 0;background-size:100% auto;position:absolute;top:-116px;left:50%;transform: translateX(-50%);-webkit-transform: translateX(-50%);-moz-transform: translateX(-50%);-o-transform: translateX(-50%);-ms-transform: translateX(-50%);}
    .lottery-sorry-kr{background-image:url(../../static/image/no_lottery_kr.png);}
    .lottery-sorry-th{background-image:url(../../static/image/no_lottery_th.png);}
    .lottery-sorry-vn{background-image:url(../../static/image/no_lottery_vn.png);}
    .lottery-alert .lottery-win-title{padding:58px 0 20px;color:#fff;font-size:30px;}
    .lottery-alert .lottery-win-img{width:84px;height:120px;margin:0 auto;padding:0 16px;border-radius:16px;background:#5861c7;}
    .lottery-alert .lottery-win-img img{width:100%;}
    .lottery-alert .lottery-win-name{padding:10px;color:#fff;font-size:36px;}
    .lottery-alert .lottery-win-tips{padding:0 10px 20px;color:#b2b8e3;font-size:18px;}
    .lottery-alert p.lottery-sorry-txt{padding:100px 0;color:#fff;font-size:30px;}
    .lottery-alert .btnsave {border-top:1px solid #5861c7;margin-top: 12px;font-size: 16px;}
    .lottery-alert .btnsave-text {text-align: center;color: #fff;font-size: 36px;margin: 14px 0;padding: 6px 0;}
    /*tab*/
    .nav-tab{padding:0 22px;}
    .tab-list{display:flex;width:100%;}
    .tab-list li{flex:1;height:80px;line-height:80px;color:#6770e6;font-size:30px;text-align:center;border-radius:30px 30px 0 0;background:#1c1939;}
    .tab-list li:first-child{margin-right:20px;}
    .tab-list li.on{color:#fff;background:#232048;}
    /*抽奖规则*/
    .lottery-rule{margin:0 22px 40px;padding:40px 33px;color:#bbbabf;font-size:24px;border-radius:0 0 16px 16px;background:#232048;}
    /*中奖记录*/
    .lottery-record{margin:0 22px 40px;padding:40px 33px;color:#bbbabf;font-size:24px;border-radius:0 0 16px 16px;background:#232048;}
    .lottery-record-title{display:flex;padding-bottom:30px;font-size:0;}
    .lottery-record-title span{flex:1;color:#bbbabf;font-size:30px;}
    .lottery-record-title span:first-child{flex:1.6;}
    .lottery-record-list li{padding:10px 0;border-top:1px solid #3b3860;}
    .lottery-record-list li p.lottery-record-con{display:flex;padding:10px 0;font-size:0;}
    .lottery-record-list li p.lottery-record-con span{flex:1;color:#bbbabf;font-size:24px;}
    .lottery-record-list li p.lottery-record-con span:first-child{flex:1.6;margin-right:10px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
    .lottery-record-list li span:last-child{white-space:nowrap;}
    .lottery-record-list li p.lottery-record-code{padding-bottom:10px;color:#6770e6;font-size:24px;}
    .copy-btn{float:right;height:36px;line-height:36px;padding:0 28px;color:#fff;font-size:24px;text-align:center;border:3px solid #6371ea;border-radius:8px;background:#4f55a5;}
    .lottery-btn{text-align:center;}
    .lottery-list-more{display:inline-block;margin:10px auto 0;color:#6770e6;font-size:36px;}
</style>


// WEBPACK FOOTER //
// src/components/lotteryIndex.vue